import { render } from "./table.vue?vue&type=template&id=2af305cb&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=2af305cb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2af305cb"

export default script